---
title: Filter
description: "A filter device: a type, a cutoff and a resonance, a panel with a handle on the curve and a live spectrum, a Web Audio engine and tools for agents."
component: true
base: base
---

<ComponentPreview styleName="base-nova" name="block-filter" />

Takes part of the spectrum out: a low-pass, a high-pass, a band-pass or a notch. It is a [device](/docs/devices): a state, a panel, an engine and tools, each its own file.

## Installation

<Install name="filter" kind="device" />

## Controls

<DeviceControls device="filter">
<Control id="type">The shape of the filter.</Control>
<Control id="cutoffHz">The frequency where the filter starts to work. Drag the handle across to set it.</Control>
<Control id="resonance">How much the filter rings around the cutoff. Drag the handle up to raise it.</Control>
</DeviceControls>

## Panel

The panel draws the curve of the filter, with a handle on it. Pass a spectrum to the panel to see what comes out behind the curve. `filterCurve(state)` is the curve it draws.

<DeviceUsage name="filter" />

## Engine

Create it, connect it and update it as for any device: see [The engine](/docs/devices#the-engine).

The node is the filter the curve draws. A low-pass and a high-pass read their resonance in decibels, so the device gives it to the node in that unit, and the curve and the sound agree. `filterSettings(state)` is what goes on the node.
